import "bootstrap/dist/css/bootstrap.min.css"
import "bootstrap/dist/js/bootstrap.min.js"
import "./src/styles/_global.css"

import React from "react"

import { RecombeeContextProvider } from "./src/contexts/RecombeeContext"

export const wrapRootElement = ({ element }) => (
  <RecombeeContextProvider>{element}</RecombeeContextProvider>
)

/* exports.onRouteUpdate = ({ location }, options) => {
  if (typeof Analytics !== "undefined") {
    if (options && options.debug) {
      console.log("analytics.page() called")
    }
    // On every route change fire this code!!
    Analytics.page()
  }
} */

export const onRouteUpdate = ({ location, prevLocation }) => {
  if (prevLocation && location.pathname === prevLocation.pathname) {
    return
  }

  const _paq = window._paq || []
  const dev = window.dev || false

  const url = location.pathname
  const prevUrl = prevLocation ? prevLocation.pathname : null

  // document.title workaround stolen from:
  // https://github.com/gatsbyjs/gatsby/blob/master/packages/gatsby-plugin-google-analytics/src/gatsby-browser.js
  const sendPageView = () => {
    const { title } = document

    prevUrl && _paq.push(["setReferrerUrl", prevUrl])
    _paq.push(["setCustomUrl", url])
    _paq.push(["setDocumentTitle", title])
    _paq.push(["trackPageView"])
    _paq.push(["enableLinkTracking"])

    if (dev) {
      console.log(`[Matomo] Page view for: ${url} - ${title}`)
    }
  }

  if ("requestAnimationFrame" in window) {
    requestAnimationFrame(() => {
      requestAnimationFrame(sendPageView)
    })
  } else {
    // simulate 2 rAF calls
    setTimeout(sendPageView, 32)
  }
}
